import React from 'react';
import { SanityImage } from 'sanity-image';
import type { ImageAsset, ImageCrop, ImageHotspot } from '@sanity/types';

interface Props {
  image: {
    asset: ImageAsset;
    crop?: ImageCrop;
    hotspot?: ImageHotspot;
  };
  alt?: string;
  className?: string;
  width?: number;
}

function Image({ image, alt, className = '', width }: Props) {
  const { asset, crop, hotspot } = image || {};
  const altText = alt || asset.altText;

  return (
    <SanityImage
      id={asset._id}
      crop={crop}
      hotspot={hotspot}
      alt={altText as string}
      projectId='97nuytc2'
      dataset={process.env.GATSBY_SANITY_DATASET || 'production'}
      className={className}
      width={width}
    />
  );
}

export default Image;
